module.exports = __webpack_public_path__ + "img/video-popup.0cfdbcf8.webp";